export default __webpack_public_path__ + "static/media/leaderboard-icon.34fc1ce1.svg";